export default __webpack_public_path__ + "static/ipad_website-1848d4ae693ea3020b1058aadb902e94.mp4";